const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype

/** `workoutId` → `workout_id`, `HTMLParser` → `html_parser`. Already-snake input is unchanged. */
const toSnakeCase = (text: string): string =>
  text
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase()

const snakeCaseValue = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(snakeCaseValue)
  if (isPlainObject(value)) return objectUtil.snakeCaseKeysDeep(value)
  return value
}

export const objectUtil = {
  toSnakeCase,
  /**
   * Rewrite every key of a plain object (recursively, through arrays) to snake_case. Values are
   * untouched; class instances such as `Date` pass through as-is. Keys that start with `$` are
   * reserved by analytics vendors (`$set`, `$set_once`) and are kept verbatim.
   */
  snakeCaseKeysDeep: (value: Record<string, unknown>): Record<string, unknown> =>
    Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key.startsWith('$') ? key : toSnakeCase(key), snakeCaseValue(entry)]),
    ),
}
